/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PersonalServiceBenefits.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import Content from 'services/Content';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import BenefitsCard from './BenefitsCard';
import BenefitsBox from './BenefitsBox';
import FinePrint from 'components/layouts/Preferences/Benefits/FinePrint';
import PSTurboTaxTable from 'components/layouts/Preferences/Benefits/PSTurbotaxTable';
import { personalServicesLinks, linkBuilder } from 'services/Externals';
import { getView } from 'state/view/ViewSelectors';
import LinkButton from 'components/shared/Buttons/LinkButton';
import { contentConverter } from 'services/Content';
import Accordion from 'components/layouts/Preferences/Benefits/Accordion/Accordion';
import turbotax_logo from 'assets/logo/turbotax-logo.png';
import {getIsRMDEligible} from "state/distribution/RequiredMinimumDistributionSelectors";

const PersonalServicesBenefits = ({ rmdEligible, view }) => {
  const markup = contentConverter.makeHtml(Content.personalServicesSubheading);
  const PersonalSolutionsAccordion = rmdEligible
    ? contentConverter.makeHtml(Content.personalSolutionsDescWRmd)
    : contentConverter.makeHtml(Content.personalSolutionsDescNoRmd);

  const turboTaxAccordionHeader = (
    <Fragment>
      <img src={turbotax_logo} alt="TurboTax Logo" />
      <LinkButton
        link={
          window.getTTOUrl
            ? window.getTTOUrl(personalServicesLinks.turboTaxLink)
            : '/#'
        }
        className="benefits-button"
        linkTarget="_blank">
        Save Now
      </LinkButton>
    </Fragment>
  );

  return (
    <Fragment>
      <PreferencesHeader>
        <div className="preferences-benefits-header">Personal Services</div>
      </PreferencesHeader>

      <PreferencesSection fullBackground className="eps-benefits-page">
        <div
          className="preferences-benefits-subheader"
          dangerouslySetInnerHTML={{ __html: markup }}
        />
        <BenefitsCard>
          <h3>
            Complimentary Research and Resources to Help With Your Investment
            Decisions
          </h3>
          <div className="flex-container">
            <BenefitsBox link={personalServicesLinks.morningstarLink}>
              <div
                dangerouslySetInnerHTML={{
                  __html: contentConverter.makeHtml(Content.morningstarBenefit)
                }}
              />
            </BenefitsBox>
            <BenefitsBox link="/profile/subscriptions">
              <div
                dangerouslySetInnerHTML={{
                  __html: contentConverter.makeHtml(Content.firstNoticeBenefit)
                }}
              />
            </BenefitsBox>
          </div>
        </BenefitsCard>
      </PreferencesSection>
      <PreferencesSection fullBackground className="eps-benefits-page">
        <BenefitsCard>
          <Accordion
            headerChildren={turboTaxAccordionHeader}
            bodyChildren={<PSTurboTaxTable />}
            title={<h3>Free TurboTax® for Personal Services Clients</h3>}
          />
        </BenefitsCard>
      </PreferencesSection>
      <div className="program-benefits ps-benefits">
        <PreferencesSection
          fullBackground
          className="eps-benefits-page flex-grower">
          <BenefitsCard>
            <div
              dangerouslySetInnerHTML={{
                __html: contentConverter.makeHtml(
                  Content.PersonalServicesProgramBenefits
                )
              }}
            />
          </BenefitsCard>
        </PreferencesSection>
      </div>
      <PreferencesSection fullBackground className="eps-benefits-page">
        <div className="ps-benefits-card-wrapper">
          <BenefitsCard>
            <Accordion
              bodyChildren={
                <div
                  dangerouslySetInnerHTML={{
                    __html: PersonalSolutionsAccordion
                  }}
                />
              }
              title={
                <div
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.personalSolutionsTitle
                    )
                  }}
                />
              }
            />
          </BenefitsCard>
        </div>
      </PreferencesSection>

      <PreferencesSection fullBackground className="eps-benefits-page">
        <PreferencesRow className="flex-container">
          <BenefitsBox link={personalServicesLinks.brokerageTradesLink}>
            <div
              dangerouslySetInnerHTML={{
                __html: contentConverter.makeHtml(
                  Content.discountedPSBrokerageTradesBenefit
                )
              }}
            />
          </BenefitsBox>
          <BenefitsBox link={linkBuilder(personalServicesLinks.iraLink, view)}>
            <div
              dangerouslySetInnerHTML={{
                __html: contentConverter.makeHtml(
                  Content.iraContributionBenefit
                )
              }}
            />
          </BenefitsBox>
          <BenefitsBox link="/profile/subscriptions">
            <div
              dangerouslySetInnerHTML={{
                __html: contentConverter.makeHtml(Content.firstNoticeBenefit)
              }}
            />
          </BenefitsBox>
          <BenefitsBox link={personalServicesLinks.charitableGivingLink}>
            <div
              dangerouslySetInnerHTML={{
                __html: contentConverter.makeHtml(
                  Content.charitableGivingBenefit
                )
              }}
            />
          </BenefitsBox>
        </PreferencesRow>
      </PreferencesSection>
      <FinePrint content={Content.psFinePrint} />
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isDesktopLayout: state.view.isDesktopLayout,
  rmdEligible: getIsRMDEligible(state),
  view: getView(state)
});

export default connect(mapStateToProps)(PersonalServicesBenefits);
